/**
 * 阿里云以图搜图结果处理工具
 *
 * 本文件不引入 HTTP 客户端，便于 Node 测试直接执行。
 */

const parseSimilarity = value => {
  const score = parseFloat(value)
  return Number.isFinite(score) ? score : -Infinity
}

/**
 * 从阿里云图搜响应中提取商品 ID：
 * - 相似度从高到低排序
 * - 同一商品只保留相似度最高的结果
 * - 无相似度的结果排在有效结果之后
 */
export const mapImageSearchToProductIds = (response) => {
  const auctions = (response && response.data && response.data.auctions) || []

  return auctions
    .filter(item => item && item.productId)
    .sort((a, b) => parseSimilarity(b.sortExprValues) - parseSimilarity(a.sortExprValues))
    .reduce((productIds, item) => {
      if (!productIds.includes(item.productId)) {
        productIds.push(item.productId)
      }
      return productIds
    }, [])
}



// WEBPACK FOOTER //
// ./src/api/imageSearch.js